import $api from "@/api/index";
import { Blog, ArticleI } from "@/types/blog";

export async function getArticles(options?: {
  limit?: number;
  offset?: number;
  signal?: AbortSignal;
}): Promise<Blog> {
  const res = await $api.get(
    "/blog/",
    options
      ? {
          params: { limit: options.limit, offset: options.offset },
          signal: options.signal,
        }
      : undefined
  );

  return res.data;
}

export async function getArticlesInfo(slug: string): Promise<ArticleI> {
  const res = await $api.get(`/blog/${slug}/`);

  return res.data;
}
